import { render, staticRenderFns } from "./LableName.vue?vue&type=template&id=33f160fe&scoped=true&"
import script from "./LableName.vue?vue&type=script&lang=js&"
export * from "./LableName.vue?vue&type=script&lang=js&"
import style0 from "./LableName.vue?vue&type=style&index=0&id=33f160fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f160fe",
  null
  
)

export default component.exports